<div class="row ng-scope">
  <div class="col-12">
    <div class="row form-group">
      <label class="control-label col-3">Mã chức vụ</label>
      <div class="col-9">
        <input type="text" #mafocus [autofocus] tabIndex="1" class="form-control" placeholder="" [(ngModel)]="doituongSelect.Ma">

      </div>
    </div>
    <div class="row form-group">
      <label class="control-label col-3 ng-binding">Tên chức vụ</label>
      <div class="col-9">
        <input type="text" (keydown)="keyTenPress($event)" tabIndex="2" class="form-control" placeholder="" [(ngModel)]="doituongSelect.Ten">
      </div>
    </div>


    <div class="row form-group">
      <label class="control-label col-3 ng-binding">Nhóm</label>
      <div class="col-9">
        <ng-select style="width:100%;" 
                   [openOnEnter]="false"
                   [items]="inputnhoms"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   placeholder=""
                   [(ngModel)]="doituongSelect.Nhom">
        </ng-select>
      </div>
    </div>
    

  </div>

</div>
<div class="modal-footer" style="display: flex;justify-content: space-between;">
        <div class="checkbox c-checkbox">
                <!--<label>
                        <input tabIndex="5" type="checkbox" [(ngModel)]="doituongSelect.Trang_Thai" />
                    <span class="fa fa-check"></span>{{hoatdong}}</label>-->
            </div>
    <div class="">
        <button style="float:left !important" class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="">Hủy bỏ</button>
        <button style="float:left !important" *ngIf="!(quyen_sua==false && doituongSelect.Id!=null && doituongSelect.Id!='0')" type="submit" (click)="saveproduct()" title="" class="mb-1 mr-1 btn btn-primary">Lưu lại</button>
    </div>
    
</div>


